/**
 * Scroll Utils
 */

// Height of header on mobile
const OFFSETDEFAULT = 80;

export const scrollTo = (element: HTMLElement | null, offset = OFFSETDEFAULT): void => {
    if (!element) return;

    const top = element?.offsetHeight - offset;
    window.scrollTo({
        top,
        behavior: 'smooth',
    });
};

export const scrollToCoord = (coord: number, offset = OFFSETDEFAULT): void => {
    const top = coord - offset;
    window.scrollTo({
        top,
        behavior: 'smooth',
    });
};

const defaultScrollIntoViewOptions: ScrollIntoViewOptions = {
    behavior: 'smooth',
    block: 'start',
    inline: 'start',
};

export const scrollIntoView = (element: Element, options = defaultScrollIntoViewOptions): void => {
    if (!element) return;
    element.scrollIntoView(options);
};
